import { render, staticRenderFns } from "./AppNavigator.vue?vue&type=template&id=077d0b5c&"
import script from "./AppNavigator.vue?vue&type=script&lang=js&"
export * from "./AppNavigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports